import { useCurrentUser } from '@jira/platform__services-user-current/src/main.tsx';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import { useActivationId } from '@atlassian/jira-tenant-context-controller/src/components/activation-id/index.tsx';

type UseAppReorderingIds = () => {
	entityAri: string;
	ownerAri: string;
	group: string;
};

export const useAppReordering: UseAppReorderingIds = () => {
	const cloudId = useCloudId();
	const activationId = useActivationId();
	const {
		data: {
			user: { accountId },
		},
	} = useCurrentUser();
	const entityAri = JiraNavigationSettingsAri.create({
		siteId: cloudId,
		activationId,
		navigationSettingScope: 'apps',
	}).toString();
	const ownerAri = IdentityUserAri.create({
		userId: accountId || 'UNKNOWN',
	}).toString();
	return { entityAri, ownerAri, group: 'SIDE_NAVIGATION_STARRED_APPS' };
};
